import React from 'react';
import { Button } from '@/components/ui/button';

type ViewOptionsProps = {
	currentView: 'grid' | 'masonry';
	 
	onChangeView: (view: 'grid' | 'masonry') => void;
	currentAspect: 'square' | 'vertical' | 'horizontal';
	 
	onChangeAspect: (aspect: 'square' | 'vertical' | 'horizontal') => void;
	backButton?: React.ReactNode;
};

const ViewOptions: React.FC<ViewOptionsProps> = ({
	currentView,
	onChangeView,
	currentAspect,
	onChangeAspect,
	backButton,
}) => {
	return (
		<div className="flex flex-col space-y-4 mb-8">
			{/* Back Button */}
			{backButton && (
				<div className="flex justify-start">
					{backButton}
				</div>
			)}

			{/* View and Aspect Options */}
			<div className="flex flex-col sm:flex-row sm:items-center sm:justify-end space-y-3 sm:space-y-0 sm:space-x-4">
				{/* View Options */}
				<div className="flex space-x-2 justify-center sm:justify-start">
					{[
						{ id: 'masonry', label: 'Masonry' },
						{ id: 'grid', label: 'Grid' },
					].map(({ id, label }) => (
						<Button
							key={id}
							variant={currentView === id ? 'default' : 'outline'}
							onClick={() => onChangeView(id as 'grid' | 'masonry')}
							className="flex-1 sm:flex-none"
						>
							{label}
						</Button>
					))}
				</div>

				{/* Aspect Ratio Options */}
				{currentView === 'grid' && (
					<div className="flex space-x-2 justify-center sm:justify-start">
						{[
							{ id: 'square', label: 'Square (1:1)', icon: '◻' },
							{ id: 'vertical', label: 'Vertical (3:5)', icon: '▯' },
							{ id: 'horizontal', label: 'Horizontal (5:3)', icon: '▭' },
						].map(({ id, label, icon }) => (
							<button
								key={id}
								className={`w-10 h-10 flex items-center justify-center font-medium text-lg transition-all duration-200 rounded-md border ${currentAspect === id
									? 'bg-gray-800 text-gray-100 border-gray-300 shadow-sm'
									: 'text-gray-600 border-gray-300 bg-white hover:bg-gray-50 hover:border-gray-400'
									}`}
								onClick={() =>
									onChangeAspect(id as 'square' | 'vertical' | 'horizontal')
								}
								title={label}
							>
								{icon}
							</button>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default ViewOptions;
